module.exports = __webpack_public_path__ + "img/migration.3472a5e.svg";